/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface RtsSubmissionDetailGet$Params {
  submissionId: string;
}

export function rtsSubmissionDetailGet(
  http: HttpClient,
  rootUrl: string,
  params: RtsSubmissionDetailGet$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, rtsSubmissionDetailGet.PATH, 'get');
  rb.path('submissionId', params.submissionId, {});
  return http
    .request(rb.build({ responseType: 'json', accept: 'application/json', context }))
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<any>)
    );
}

rtsSubmissionDetailGet.PATH = '/Rts/submission/{submissionId}';
